import { render } from "./ResourceContextMenu.vue?vue&type=template&id=45538b6e"
import script from "./ResourceContextMenu.vue?vue&type=script&lang=js"
export * from "./ResourceContextMenu.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__